// src/App.js
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { UserProvider } from "./contexts/UserContext";
import { AIWorkflowProvider } from "./contexts/AIWorkflowContext";

// --- Page & Component Imports ---
import LoginPage from "./components/auth/LoginPage";
import SignupPage from "./components/auth/SignupPage";
import ForgotPassword from "./components/auth/ForgotPasswordPage";
import ResetPassword from "./components/auth/ResetPasswordPage";
import VerifyEmail from "./components/auth/VerifyEmail";
import OAuthCallback from "./components/auth/OAuthCallback";
import ProfileSetup from "./components/ProfileSetup";
import Dashboard from "./components/dashboard/Dashboard";
import AIMatchmakingPage from "./pages/AIMatchmakingPage";
import ResumeBuilderPage from "./pages/ResumeBuilderPage";
import JobListingAIPage from "./pages/JobListingAIPage";
import ResumeOptimizationPage from "./pages/ResumeOptimizationPage";
import ComingSoonPage from "./pages/ComingSoonPage.jsx";
import ComingSoonPage2 from "./pages/ComingSoonPage2.jsx";
import RouteManager from "./components/RouteManager";
import LandingPage from "./components/LandingPage/LandingPage";
import ContactUsPage from "./components/LandingPage/ContactUsPage";
import CoverLetterPage from "./pages/CoverLetterPage";
// --- CSS ---
import "./index.css";

// --- Main App Structure ---
function App() {
  return (
    <UserProvider>
      <AuthProvider>
        <AIWorkflowProvider>
          <Routes>
            {/* Wrap ALL routes that depend on auth state within RouteManager */}
            <Route element={<RouteManager />}>
              {/* Public-Only Routes (for logged-out users) */}
              <Route path="/login" element={<LoginPage />} />
              <Route path="/signup" element={<SignupPage />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/verify-email" element={<VerifyEmail />} />
              {/* Changed LandingPage path to lowercase for consistency */}
              <Route path="/landingpage" element={<LandingPage />} />
              <Route path="/contact" element={<ContactUsPage />} />

              {/* Public Routes (accessible always) */}
              <Route path="/oauth-callback" element={<OAuthCallback />} />
              <Route path="/coming-soon" element={<ComingSoonPage />} />
              <Route path="/coming-soon-page-2" element={<ComingSoonPage2 />} />

              {/* Authenticated Routes */}
              <Route path="/profile-setup" element={<ProfileSetup />} />
              <Route path="/dashboard" element={<Dashboard />}>
                <Route
                  index
                  element={<Navigate to="ai-matchmaking" replace />}
                />
                <Route path="ai-matchmaking" element={<AIMatchmakingPage />} />
                <Route path="resume-builder" element={<ResumeBuilderPage />} />
                <Route path="job-listing" element={<JobListingAIPage />} />
                <Route
                  path="resume-optimization"
                  element={<ResumeOptimizationPage />}
                />
                <Route path="cover-letter" element={<CoverLetterPage />} />
                {/* Add other dashboard routes here */}
                <Route
                  path="*"
                  element={
                    <div className="p-6 text-center">
                      Dashboard Section Not Found
                    </div>
                  }
                />
              </Route>

              {/* Add any other authenticated routes here */}
            </Route>{" "}
            {/* End RouteManager */}
            {/* Default fallback: redirect to landingpage if no other route matches */}
            {/* This also handles the root path "/" for unauthenticated users after RouteManager decides to Outlet */}
            <Route path="*" element={<Navigate to="/landingpage" replace />} />
          </Routes>
        </AIWorkflowProvider>
      </AuthProvider>
    </UserProvider>
  );
}

export default App;
